import React, { useMemo } from 'react';
import { mainland, mapPalette, perth, tasmania } from '../data/australia';
import { isPointInPolygon, sampleColor } from '../utils/geo';
const STEP = 1.1;
const VIEW = {
  x: 112,
  y: 9,
  width: 43.5,
  height: 36
};
export function AustraliaDotMap() {
  const dots = useMemo(() => {
    const list: {
      x: number;
      y: number;
      color: string;
    }[] = [];
    for (let lon = 113; lon <= 154; lon += STEP) {
      for (let lat = -10.5; lat >= -44; lat -= STEP) {
        const point: [number, number] = [lon, lat];
        if (isPointInPolygon(point, mainland) || isPointInPolygon(point, tasmania)) {
          const t = (lon - 113) / 41 * 0.75 + (-lat - 10) / 34 * 0.25;
          list.push({
            x: lon,
            y: -lat,
            color: sampleColor(mapPalette, t)
          });
        }
      }
    }
    return list;
  }, []);
  const baseLeft = (perth[0] - VIEW.x) / VIEW.width * 100;
  const baseTop = (-perth[1] - VIEW.y) / VIEW.height * 100;
  return <figure className="relative" data-id="element-21" data-mp="3f595pdicmtny">
      <svg viewBox={`${VIEW.x} ${VIEW.y} ${VIEW.width} ${VIEW.height}`} className="h-auto w-full" role="img" aria-label="Map of Australia in AFB's dot pattern, marking the Bibra Lake, Perth base and deployment Australia-wide" data-id="element-22" data-mp="3f6apc6dfkoha">
        {dots.map(dot => <circle key={`${dot.x}-${dot.y}`} cx={dot.x} cy={dot.y} r={0.36} fill={dot.color} data-id="element-23" data-mp="g5vphcg145vj" />)}
        <circle cx={perth[0]} cy={-perth[1]} r={0.75} fill="#12DBB4" className="ping-soft" data-id="element-24" data-mp="b7c5hhkzx45t" />
        <circle cx={perth[0]} cy={-perth[1]} r={0.7} fill="#0B0B0C" stroke="#ffffff" strokeWidth={0.22} data-id="element-25" data-mp="17x39c7f6g3oa" />
      </svg>
      <div className="pointer-events-none absolute -translate-y-1/2 pl-5" style={{
      left: `${baseLeft}%`,
      top: `${baseTop}%`
    }} data-id="element-26" data-mp="yyhhflntfcau">
        <div className="whitespace-nowrap rounded-lg border border-afb-line bg-white px-3 py-2 shadow-[0_8px_24px_-12px_rgba(11,11,12,0.35)]" data-id="element-27" data-mp="tz4vd34rq99b">
          <p className="text-[13px] font-semibold text-afb-ink" data-id="element-28" data-mp="3epvodthsaxny">Bibra Lake, WA</p>
          <p className="text-xs text-afb-muted" data-id="element-29" data-mp="3es8ckoe4y49g">Base and demo site</p>
        </div>
      </div>
    </figure>;
}